import request from '@/utils/request'

export function rewardReferral(data) {
  return request({
    url: '/admin/referral/reward',
    method: 'post',
    data
  })
}
